var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","aria-controls":_vm.disclosureId,"aria-expanded":_vm.expanded.toString()},on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }